import React, {useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import Utility from "../../common/utility";
import ApiCalls from "../apis/api-calls";
import Cookies from "universal-cookie";


const VerifiedEmail = inject("sharedStore","loginStore")(
  observer((store) => {
    const {
      sharedStore,
      loginStore,
      history,
      location: { search },
    } = store;

    const [loadPage,setLoadPage] = useState(false)
    const [status, setStatus] = useState("")

    useEffect(()=>{
      confirmEmail();
    },[])

    
 const confirmEmail = ()=> {
    sharedStore.showLoader();
    const params = new URLSearchParams(search);
    const token = params.get("token");
    const type = params.get("type");
    if (token && type === "verify") {
      ApiCalls.confirmEmail(token, "verify")
        .then((res) => {
          sharedStore.hideLoader();
          
          const cookies = new Cookies();
          if (cookies.get("auth") === "true") {
            console.log("cookies.get", cookies.get("auth"));
            cookies.set("auth", false, { domain: ".izenda.com" });
            cookies.set("auth", false, { path: "/" });
            loginStore.logout();
          }
          // eslint-disable-next-line no-unused-vars
          let status = "";
          if (res.status_code === 200) {
            if (res.token_status === "expired") {
              status = "expired";
              Utility.setData("user_id", res.user_id);
            } else if (res.token_status === "used") {
              status = "used";
            } else {
              status = "valid";
              Utility.setData("user_id", res.user_id);
            }
            setLoadPage(true)
            setStatus(status)
          } else if (res.status_code === 409) {
            history.push("/verification-expired", {
              status: "token_used",
            });
          } else {
            setLoadPage(false)
            history.push("/invalid-token", { token: true });
          }
        })
        .catch((err) => {
          sharedStore.hideLoader();
          console.log("err", err);

         history.push("/invalid-token", { token: true });
        });
    } else {
      sharedStore.hideLoader();
      history.push("/invalid-token", { token: false });
    }
  }

  const renderPage = ()=> {
    if (status === "") {
      return null;
    } else if (status === "expired") {
      history.push("/verification-expired", { status: "error" });
    } else if (status === "used") {
      history.push("/thankyou", { status: "verified" });
    } else if (status === "valid") {
      history.push(`/thankyou`, { status: "valid" });
    }
  }

  
  return (
  <div>{loadPage === "" ? null : renderPage()}</div>
  );
  }))


  export default VerifiedEmail;



// WEBPACK FOOTER //
// ./src/components/VerifiedEmail/VerifiedEmail.jsx